import { Fragment, useRef } from 'react';
import { View } from 'react-native';

import AddReviewOrDisputeModal from '../../../Components/AddReviewOrDisputeModal';
import Button from '../../../Components/Button';
import ScreenWrapper from '../../../Components/ScreenWrapperWithTitleAnimation';
import modals from '../../../Components/Sheets/modals';
import StatusFilter from '../../../Components/StatusFilter';
import { ScaleButtonAnimation } from '../../../Components/Web/Intereaction';
import constants from '../../../Config/constants';
import ThemeStyle from '../../../Theme/styles';

import useController from '../controller/OrderHistory.controller';

import ItemLoader from './ItemLoader';
import OrderItem from './OrderItem';

const ClickableComponent = constants.isWeb ? ScaleButtonAnimation : Button;
const clickableProps = constants.isWeb
  ? {
      buttonStyle: ThemeStyle.webPageWrapper,
      contentStyle: ThemeStyle.webPageContainer,
    }
  : { plain: true };

const statusOptions = [
  { label: 'Completed', value: 'completed' },
  { label: 'Refunded', value: 'refunded' },
  { label: 'Cancelled', value: 'cancelled' },
];
const OrderHistory = (props) => {
  const listRef = useRef();
  const {
    state: { filterStatus, reviewModalData, reviewModalShow },
    fetchOrderHistory,
    onFetchedOrderHistory,
    onItemPressed,
    onReviewNotNow,
    onReviewPress,
    onStatusChange,
    toggleWebOrderAgain,
  } = useController(listRef);

  const _showOrderAgain = (data) => (e) => {
    if (constants.isWeb) {
      e.preventDefault();
      toggleWebOrderAgain(data);
    } else {
      modals.show(modals.ORDER_AGAIN, data);
    }
  };

  const _renderHeader = () => (
    <StatusFilter
      type="orders"
      status={filterStatus}
      options={statusOptions}
      optionLabel="Select order status"
      onChange={(res) => onStatusChange(res.value)}
    />
  );

  const _renderItem = ({ item }) => {
    if (item.loading) {
      return <ItemLoader />;
    }

    return (
      <ClickableComponent
        onPress={onItemPressed(item)}
        href={
          constants.isWeb && `/order_details?id=${item?.transaction_number}`
        }
        {...clickableProps}
      >
        <OrderItem onOrderAgain={_showOrderAgain(item)} {...item} />
      </ClickableComponent>
    );
  };

  return (
    <Fragment>
      <ScreenWrapper
        onRef={(r) => (listRef.current = r)}
        initialData={[
          { loading: true },
          { loading: true },
          { loading: true },
          { loading: true },
          { loading: true },
        ]}
        title="Order History"
        stickyHeaderIndices={[0]}
        renderItem={_renderItem}
        onRequest={fetchOrderHistory}
        onRequestEnd={onFetchedOrderHistory}
        ListHeaderComponent={_renderHeader}
        withSeparator
      />

      <AddReviewOrDisputeModal
        show={reviewModalShow}
        data={reviewModalData}
        onReview={onReviewPress}
        onNotNow={onReviewNotNow}
      />
    </Fragment>
  );
};

export default OrderHistory;
